import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Plus, History, Settings, BarChart3, PieChart, ShoppingCart } from 'lucide-react';
import { cn } from '../lib/utils';
import { useAuth } from '../context/AuthContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, canViewDashboard, canModifyChiusure } = useAuth();

  // Items base visibili a tutti gli utenti autenticati
  const allNavItems = [
    { path: '/', icon: Home, label: 'Home', visible: true },
    { path: '/nuova-chiusura', icon: Plus, label: 'Nuova', visible: canModifyChiusure() },
    { path: '/chiusure', icon: History, label: 'Storico', visible: true },
    { path: '/analytics', icon: BarChart3, label: 'Analytics', visible: canViewDashboard() },
    { path: '/venduto', icon: PieChart, label: 'Venduto', visible: true },
    { path: '/acquisti', icon: ShoppingCart, label: 'Acquisti', visible: true },
    { path: '/impostazioni', icon: Settings, label: 'Altro', visible: true },
  ];

  // Filtra solo gli items visibili per il ruolo corrente
  const navItems = allNavItems.filter(item => item.visible);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav fixed bottom-0 left-0 right-0 bg-white border-t border-border z-50 safe-bottom">
      <div className="max-w-lg mx-auto">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            
            return (
              <button
                key={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex flex-col items-center justify-center flex-1 min-w-0 h-full transition-colors touch-target",
                  active ? "text-primary" : "text-muted-foreground"
                )}
              >
                <Icon className={cn(
                  "w-5 h-5 transition-transform",
                  active && "scale-110"
                )} />
                <span className="text-[10px] mt-1 font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
